<template>
  <div class="card p-3 mt-3 mb-5" style="background: #f2f2f2">
    <div class="card-body">
      <p class="text-muted small rightcol">
        <strong>About the National Safety Council </strong>
        <br/>
        The National Safety Council is America's leading nonprofit
        safety advocate - and has been for over 100 years. As a
        mission-based organization, we work to eliminate the leading
        causes of preventable death and injury, focusing our efforts
        on the workplace, roadway and impairment. We create a culture
        of safety to not only keep people safer at work, but also
        beyond the workplace so they can live their fullest lives.
      </p>
      <div class="text-center">
        <a href="http://www.norc.org/" target="_blank">
          <img
              src="https://nscmediacdn.azureedge.net/nsc/calculators/substance/norc.png"
              alt="NORC"
              class="img-fluid mt-3 mb-3"
          />
        </a>
      </div>
      <p class="text-muted small rightcol">
        <strong>About NORC</strong>
        <br/>
        NORC at the University of Chicago is an independent research
        institution that delivers reliable data and rigorous analysis
        to guide critical programmatic, business, and policy
        decisions. Since 1941, NORC has conducted groundbreaking
        studies, created and applied innovative methods and tools, and
        advanced principles of scientific integrity and collaboration.
        Today, government, corporate, and nonprofit clients around the
        world partner with NORC to transform increasingly complex
        information into useful knowledge. Please visit
        <a href="https://www.norc.org" target="_blank">www.norc.org</a>
        for more information.
      </p>
      <div class="text=center">
        <a href="http://www.nationwide.com" target="_blank">
          <img
              src="https://nscmediacdn.azureedge.net/nsc/calculators/substance/nationwide.png?120220"
              alt="Nationwide"
              class="img-fluid mt-3 mb-3"
          />
        </a>
      </div>
      <p class="text-muted small rightcol">
        <strong>About Nationwide</strong>
        <br/>
        Since 1926, Nationwide has been committed to helping people
        protect what's most important. Understanding how substance use
        impacts our communities, whether business or personal, is
        critical to planning a safe and productive future.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "RightColumn"
}
</script>

<style scoped>

</style>